import React from "react"
import styled from "styled-components"
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core"

const GradesFilter = styled.div`
  margin: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const GradeFilter = ({ onGradeSelected, gradeCheckedState }) => {
  return (
    <GradesFilter>
      <FormControl>
        <FormGroup>
          {gradeCheckedState &&
            Object.keys(gradeCheckedState).map(key => (
              <FormControlLabel
                onChange={e => onGradeSelected(gradeCheckedState[key].name, e)}
                key={key}
                control={<Checkbox />}
                label={gradeCheckedState[key].name}
                name={key}
                checked={gradeCheckedState[key].checked}
              />
            ))}
        </FormGroup>
      </FormControl>
    </GradesFilter>
  )
}

export default GradeFilter
